import React, { useState } from 'react';
import axios from 'axios';
import ImageGallery from './ImagesGallery';
import UploadIcon from '@mui/icons-material/Upload';
import './UploadImageCloudinary.css';
import SidebarMenu from "../../sidebar/sidebar";


const UploadPageCloud = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imgUpdate, setImgUpdate] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  // פונקציה לטיפול בשינוי קובץ
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  // פונקציה להעלאת התמונה
  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await axios.post('https://medical-center-znya.onrender.com/cloudinary', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // מקבלים את הקישור לתמונה מה-Backend
      setImageUrl(response.data.url);
      alert('התמונה נקלטה בהצלחה');
      setImgUpdate(!imgUpdate);

      // מאפס את הסטייטים של הקובץ והתמונה לאחר העלאה
      setSelectedFile(null);
      setImageUrl(null);
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('Error uploading image.');
    }
  };

  return (
    <div className='ImgManagerContainer'>
      <SidebarMenu />
      <div className='ImgManagerTitle'>ניהול תצוגת תמונות במוניטור</div>
      <div className='uploadImgContainer'>
        {/* הסתרה של כפתור הקובץ האמיתי */}
        <input 
          id="file-upload" 
          className='uploadImg' 
          type="file" 
          onChange={handleFileChange} 
          style={{ display: 'none' }} // הסתרה מוחלטת של כפתור הקובץ
        />
        {/* כפתור מותאם אישית לפתיחת דיאלוג הקובץ */}
        <label htmlFor="file-upload" className="uploadLabel">
          {selectedFile ? selectedFile.name : 'העלה תמונה'} {/* אם יש קובץ שנבחר, מציגים את שם הקובץ */}
        </label>
        {/* כפתור העלאה לאחר שבחרת קובץ */}
        <button className='uploadBtn' onClick={handleUpload}>
          <UploadIcon />
        </button>
      </div>
      <ImageGallery updateImgs={imgUpdate}/>
    </div>
  );
};

export default UploadPageCloud;
